export const footer = {
  headline1: {
    en: 'Information',
    dk: 'Information',
  },
  headline2: {
    en: 'Useful links',
    dk: 'Brugbare links',
  },
  headline3: {
    en: 'Our mission',
    dk: 'Vores mission',
  },
  headline4: {
    en: 'Blog posts',
    dk: 'Blog indlæg',
  },
  mission: {
    en: 'We exist to help organizations. Organizations that aim to deliver extraordinary results are constantly under pressure to change. We are passionate about helping your organization implement continuous improvement – so you can be the best at what you‘re passionate about.',
    dk: 'Vi eksisterer for at hjælpe organisationer. Organisationer som kan og skal levere ekstraordinære resultater, er under konstant forandringspres. Vi brænder for at hjælpe din organisation med at implementere kontinuerlige forbedringer, så I bliver bedre til det I brænder for.'
  }
};

export const general = {
  buttonReadMore: {
    en: 'Read more',
    dk: 'Læs mere',
  },
};

export const navigation = {
  home: {
    en: 'Home',
    dk: 'Forside',
  },
  ourTools: {
    en: 'Our tools',
    dk: 'Vores værktøjer',
  },
  methodology: {
    en: 'Methodology',
    dk: 'Metode',
  },
  projects: {
    en: 'Projects',
    dk: 'Projekter',
  },
  blog: {
    en: 'Blog',
    dk: 'Blog',
  },
  services: {
    en: 'Services',
    dk: 'Services',
  },
  about: {
    en: 'About us',
    dk: 'Om os',
  },
  contact: {
    en: 'Contact',
    dk: 'Kontakt',
  },
  signin: {
    en: 'Sign in',
    dk: 'Log ind',
  },
};



// WEBPACK FOOTER //
// ./src/intl.js